import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import venderThumb from "../images/vender-1.svg";
import { useForm } from "react-hook-form";
import profileThumb from "../images/profileThumb.png";
import itemThumb from "../images/itemThumb.svg";
import itemProfile from "../images/itemProfile.svg";
import { getMailFromToken, newPassword, loggedIn } from "./API Functions";
import queryString from "query-string";
import { setAppElement } from "react-modal";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

function CreatePassword() {
    const { register, handleSubmit } = useForm();
    const [passwordShown, setPasswordShown] = useState(false);
    const [is_reset, setIsReset] = useState(false);
    const [toggleEye, setToggleEye] = useState(false);
    const [accepted_terms, setAcceptedTerms] = useState(false);
    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
        toggle();
    };
    function toggle() {
        setToggleEye(toggleEye ? false : true);
    }

    const [passwordShown2, setPasswordShown2] = useState(false);
    const [toggleEye2, setToggleEye2] = useState(false);
    const togglePasswordVisiblity2 = () => {
        setPasswordShown2(passwordShown2 ? false : true);
        toggle2();
    };
    function toggle2() {
        setToggleEye2(toggleEye2 ? false : true);
    }

    const [token, setToken] = useState("");
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [password_confirm, setPasswordConfirm] = useState("");
    const [loading, setLoading] = useState(false);

    const [passwordError, setPasswordError] = useState("");
    const [password_confirmError, setPasswordConfirmError] = useState("");
    const [resetError, setResetError] = useState("");
    const [acceptedTermsError, setAcceptedTermsError] = useState("");


    useEffect(() => {
        const token = queryString.parse(window.location.search);
        getMailFromToken(token.token).then(res => {
            if (res) {
                setToken(res.token);
                setEmail(res.email);
                setName(res.nombre);
            }
        });
        const pathname = window.location.pathname
        if(pathname.includes('new')){
            setIsReset(true);
        }
    }, [])

    function validateFields() {
        let passwordError = ""
        let password_confirmError = ""
        let acceptedTermsError = ""
        if (password == "") {
            passwordError = "Selecciona una opción"
        }
        if (password_confirm == "") {
            password_confirmError = "Requerido"
        }
        if(!is_reset){
            if (accepted_terms == false) {
                acceptedTermsError = "Tienes que aceptar los términos y condiciones"
            }
        }
        if (password_confirmError || passwordError || acceptedTermsError) {
            setPasswordError(passwordError);
            setPasswordConfirmError(password_confirmError);
            setAcceptedTermsError(acceptedTermsError);
            return false
        } else {
            setPasswordError(passwordError);
            setPasswordConfirmError(password_confirmError);
            setAcceptedTermsError(acceptedTermsError);
            return true
        }
    }

    function submit() {
        setLoading(true);
        const isValid = validateFields();
        const data = {
            email: email,
            password: password,
            password_confirmation: password_confirm,
            token: token
        };
        if (isValid) {
            newPassword(data).then(res => {
                if (res) {
                    //sessionStorage.setItem('user_token', res.data.token);
                    var one_day = new Date();
                    var today = new Date();
                    one_day.setDate(today.getDate() + 1);
                    cookies.set('user_token', res.data.token, {
                        path: '/',
                        expires: one_day
                    });
                    //console.log(res);
                    window.location.replace("/catalogo")
                } else {
                    setResetError("Error al ingresar nuevo password")
                    setTimeout(() => {
                        setResetError("")
                    }, 2000);
                }
            });
        }
        setTimeout(() => {
            setLoading(false);
        }, 1200);
    }

    return (
        <div>
            <div className="loginContainer">
                <div className="loginContainer-nav">

                    <div className="loginContainer-nav__item">



                    </div>
                    <div className="loginContainer-nav__item">
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0)">
                                <path d="M22.5925 16.8231C23.9383 16.8904 25.0654 15.8137 25.0654 14.468V12.1633C25.0654 11.8773 25.4019 11.7259 25.6206 11.9109L30.9869 16.3016C31.4243 16.6549 31.9458 16.8399 32.4841 16.8399C33.1738 16.8399 33.8467 16.5371 34.3009 15.982C35.1252 14.9726 34.9738 13.4923 33.9645 12.668L29.4224 8.9502C29.086 8.68104 29.086 8.17636 29.4224 7.90721L33.9645 4.18945C34.9738 3.36515 35.1252 1.88478 34.3009 0.875431C33.4766 -0.133915 31.9963 -0.285317 30.9869 0.538982L25.6206 4.92964C25.4019 5.11468 25.0654 4.94646 25.0654 4.6773V2.42309C25.0654 1.16141 24.0897 0.067954 22.828 0.000664339C21.4822 -0.0666254 20.3551 1.01001 20.3551 2.3558V14.4007C20.3551 15.6623 21.3308 16.7558 22.5925 16.8231ZM13.4075 19.1782C12.0617 19.1109 10.9346 20.1876 10.9346 21.5334V23.838C10.9346 24.124 10.5981 24.2754 10.3794 24.0904L5.01308 19.6997C4.5757 19.3465 4.05421 19.1614 3.51589 19.1614C2.82617 19.1614 2.15327 19.4642 1.69907 20.0194C0.874766 21.0287 1.02617 22.5091 2.03551 23.3334L6.57757 27.0511C6.91402 27.3203 6.91402 27.825 6.57757 28.0941L2.03551 31.8119C1.02617 32.6362 0.874766 34.1165 1.69907 35.1259C2.52336 36.1352 4.00374 36.2866 5.01308 35.4623L10.3794 31.0717C10.5981 30.8866 10.9346 31.0549 10.9346 31.324V33.5614C10.9346 34.8231 11.9103 35.9165 13.172 35.9838C14.5178 36.0511 15.6449 34.9745 15.6449 33.6287V21.5838C15.6449 20.339 14.6692 19.2455 13.4075 19.1782ZM8.41121 0.000664339C3.76822 0.000664339 0 3.76889 0 8.41188C0 13.0549 3.76822 16.8231 8.41121 16.8231C13.0542 16.8231 16.8224 13.0549 16.8224 8.41188C16.8224 3.76889 13.0542 0.000664339 8.41121 0.000664339ZM8.41121 12.1128C6.3757 12.1128 4.71028 10.4474 4.71028 8.41188C4.71028 6.37636 6.3757 4.71094 8.41121 4.71094C10.4467 4.71094 12.1122 6.37636 12.1122 8.41188C12.1122 10.4474 10.4467 12.1128 8.41121 12.1128ZM33.6449 25.2343H21.5327C20.2374 25.2343 19.1776 26.2941 19.1776 27.5894C19.1776 28.8848 20.2374 29.9446 21.5327 29.9446H33.6449C34.9402 29.9446 36 28.8848 36 27.5894C36 26.2941 34.9402 25.2343 33.6449 25.2343Z" fill="#111111" />
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <rect width="36" height="36" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>

                    </div>
                    <div className="loginContainer-nav__item">

                    </div>

                </div>
                <div className="loginContainer-form">

                    <div className="loginContainer-card">
                        <h3 className="loginContainer-card__title">
                            Crea tu nueva contraseña.
                        </h3>
                        <div className="fieldError">{resetError}</div>
                        <div className="loginContainer-card__input">
                            <div className="fieldError">{passwordError}</div>
                            <div className="pass-wrapper">
                                <input
                                    placeholder="Password"
                                    name="password"
                                    placeholder="Contraseña"
                                    type={passwordShown ? "text" : "password"}
                                    ref={register({ required: "This is required." })}
                                    onChange={e => setPassword(e.target.value)}
                                />
                                {toggleEye ? (
                                    <svg onClick={togglePasswordVisiblity} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.0002 1L1.09961 19" stroke="#081027" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.16603 12.7999C5.57487 11.1999 5.57487 8.6999 7.16603 7.0999C8.75719 5.4999 11.2434 5.4999 12.8345 7.0999" stroke="#081027" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.36523 16.6C8.16081 16.8 9.05584 17 9.95087 17C16.9122 17 18.9011 9.99995 18.9011 9.99995C18.9011 9.99995 18.4039 8.39995 17.2105 6.69995" stroke="#081027" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M15.221 4.7C13.9282 3.7 12.2376 3 9.95028 3C2.98895 3 1 10 1 10C1 10 1.89503 13.2 4.67956 15.3" stroke="#081027" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                ) : (
                                        <svg onClick={togglePasswordVisiblity} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 14C12.2091 14 14 12.2091 14 10C14 7.79086 12.2091 6 10 6C7.79086 6 6 7.79086 6 10C6 12.2091 7.79086 14 10 14Z" stroke="#ACACB5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M19 10C19 10 17 3 10 3C3 3 1 10 1 10C1 10 3 17 10 17C17 17 19 10 19 10Z" stroke="#ACACB5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    )}
                            </div>
                        </div>
                        <div className="loginContainer-card__input"></div>
                        <div className="fieldError">{password_confirmError}</div>
                        <div className="pass-wrapper">
                            <input
                                placeholder="Password"
                                name="password"
                                placeholder="Confirmar contraseña"
                                type={passwordShown2 ? "text" : "password"}
                                ref={register({ required: "This is required." })}
                                onChange={e => setPasswordConfirm(e.target.value)}
                            />
                            {toggleEye2 ? (
                                <svg onClick={togglePasswordVisiblity2} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.0002 1L1.09961 19" stroke="#081027" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.16603 12.7999C5.57487 11.1999 5.57487 8.6999 7.16603 7.0999C8.75719 5.4999 11.2434 5.4999 12.8345 7.0999" stroke="#081027" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.36523 16.6C8.16081 16.8 9.05584 17 9.95087 17C16.9122 17 18.9011 9.99995 18.9011 9.99995C18.9011 9.99995 18.4039 8.39995 17.2105 6.69995" stroke="#081027" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15.221 4.7C13.9282 3.7 12.2376 3 9.95028 3C2.98895 3 1 10 1 10C1 10 1.89503 13.2 4.67956 15.3" stroke="#081027" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            ) : (
                                    <svg onClick={togglePasswordVisiblity2} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 14C12.2091 14 14 12.2091 14 10C14 7.79086 12.2091 6 10 6C7.79086 6 6 7.79086 6 10C6 12.2091 7.79086 14 10 14Z" stroke="#ACACB5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M19 10C19 10 17 3 10 3C3 3 1 10 1 10C1 10 3 17 10 17C17 17 19 10 19 10Z" stroke="#ACACB5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                )}
                        </div>
                        {!is_reset ?
                        <div className="loginContainer-card__row">
                            <label class="checkboxContainer">
                                He leído y acepto las <Link className="textLink" to="/terminos" target="_blank">Condiciones del servicio</Link> y la <Link className="textLink" to="/privacidad" target="_blank">Política de privacidad</Link> de Okki.
                                    <input
                                    type="checkbox"
                                    name="category"
                                    value={accepted_terms}
                                    onChange={e => setAcceptedTerms(!accepted_terms)}
                                />
                                <span className="checkmarkSquare checkmarkSquare2"></span>
                            </label>
                        </div>
                        :
                        null
                        }
                    
                        <div className="fieldError">{acceptedTermsError}</div>

                      
                        <div className="loginContainer-card__row">
                            <div className="loginContainer-card__row"></div>
                            <a className="button u-pull-right aButton buttonFull" onClick={submit}>
                                {loading && (
                                    <i className="" style={{ marginRight: "5px" }} />
                                )}
                                {loading && (
                                    'Guardando...'
                                )}
                                {!loading && (
                                    is_reset ? 'Reestablecer password' : 'Crear cuenta'
                                )}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreatePassword;
